import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link
      to={`/categories/${item?.slugPath || item?.slug}`}
      className="category-card-wrapper"
    >
      <div className="cat-card">
        {/* <div className="category-image-container"> */}
          {item?.image && (
            <img src={item?.image} alt={item?.name} className="cat-img" />
          )}
          {/* <div className="category-overlay"></div> */}
        {/* </div> */}
        {/* <div className="category-title-box"> */}
          <h3 className="cat-title">{item.name}</h3>
        {/* </div> */}
      </div>
    </Link>
  );
}

export default Card;
